/**
 * Reducer for pages module
 */
import Immutable from 'seamless-immutable';
import * as actionTypes from './actionTypes';

const initialState = Immutable({
  byId: {},
  params: {},
  error: {},
  actionsloading: false,
  lastCreatedPageUid: '',
});

export function pageReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_PAGE:
    case actionTypes.FETCH_PAGES:
    case actionTypes.CLEAR_PAGES:
      // case actionTypes.UPDATE_PAGE:
      return {
        ...state,
        byId: {},
        actionsloading: true,
      };
    case actionTypes.SAVE_PAGE:
    case actionTypes.UPDATE_PAGE:
    case actionTypes.UPDATE_PAGE_SORT_ORDER:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.DELETE_PAGE:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.SAVE_PAGE_SUCCESS:
    case actionTypes.UPDATE_PAGE_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.updated_page.pageUid]: action.payload.updated_page,
        },
        lastCreatedPageUid: action.payload.updated_page.pageUid,
        actionsloading: false,
      };
    case actionTypes.FETCH_PAGES_SUCCESS:
    case actionTypes.FETCH_PAGE_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        params: action.payload.params || {},
        actionsloading: false,
      };
    case actionTypes.UPDATE_PAGE_SORT_ORDER_SUCCESS:
      action.payload.data.forEach(function (key, index) {
        state.byId[key['pageUid']]['sort_order'] = key['sort_order'];
      });
      return {
        ...state,
        byId: state.byId,
        actionsloading: false,
      };
    case actionTypes.DELETE_PAGE_SUCCESS:
      Object.keys(state.byId).forEach(function (key, index) {
        if (state.byId[key].pageUid === action.payload.id) {
          delete state.byId[key];
        }
      });
      return {
        ...state,
        byId: state.byId,
        actionsloading: false,
      };
    default:
      return state;
  }
}
